import _get from 'lodash/get';
import { connect } from 'react-redux';
import { mapPlotMetadataToPlotId } from 'js/containers/legacy/GraphSection';
import { hide } from 'js/store/actions/modal';
import { postFeedback } from 'js/store/actions/downloadMenu';
import { setWindowLocationToUrl } from 'js/helpers/apiData';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';
import FeedbackOrDownloadMenuBody from 'js/components/legacy/FeedbackOrDownloadMenuBody';
import { constructDownloadMenuId } from 'js/store/reducers/nav/downloadMenu';

function mapStateAndPropsToDownloadMenu(state, props) {
  return state.downloadMenu[constructDownloadMenuId(state.countryMetadata.metadata.countryCode, mapPlotMetadataToPlotId(props.plotMetadata))];
}

export default connect(function (state, ownProps) {
  return {
    showDateRange: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.date_range'),
    showSampleRates: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.sample_rate'),
    plotId: mapPlotMetadataToPlotId(ownProps.plotMetadata),
    plotCountryCode: state.countryMetadata.metadata.countryCode,
    menuLoading: mapStateAndPropsToDownloadMenu(state, ownProps).loading,
    menuSubmitting: mapStateAndPropsToDownloadMenu(state, ownProps).submitting,
    menuLoadError: !mapStateAndPropsToDownloadMenu(state, ownProps).loading && !mapStateAndPropsToDownloadMenu(state, ownProps).metadata,
    menuLoadErrorMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_ERROR_MESSAGE'),
    features: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.features'),
    featuresTitle: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.feedback_title'),
    contactCheckboxText: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.contact_checkbox'),
    submitButtonText: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.button_download'),
    downloadDescription: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.download_description'),
    downloadTitle: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.download_title'),
    provideFeedbackTitle: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.general_feedback_title'),
    provideFeedbackSubtitle: _get(mapStateAndPropsToDownloadMenu(state, ownProps), 'metadata.general_feedback_subtitle'),
    feedbackSubmitFailureMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_SUBMIT_ERROR_MESSAGE'),
    isMobileWidth: state.device.isMobileWidth
  };
}, function (dispatch, ownProps) {
  return {
    submitFeedback: function submitFeedback(postFormData, countryCode, plotId) {
      return dispatch(postFeedback(countryCode, plotId, postFormData));
    },
    navigateToDownloadUrl: function navigateToDownloadUrl(countryCode, feedbackPromise) {
      feedbackPromise.then(function (feedbackResponse) {
        var downloadToken = _get(feedbackResponse, 'download_token');

        if (!downloadToken) return;
        setWindowLocationToUrl("".concat(ownProps.downloadDataUrl, "&token=").concat(downloadToken));
      });
    },
    modalClose: function modalClose() {
      return dispatch(hide('DownloadModal'));
    }
  };
})(FeedbackOrDownloadMenuBody);